module.exports = __webpack_public_path__ + "img/日发电量 (2).050be9ec.png";